module.exports = __webpack_public_path__ + "img/cliente01.13ebbb20.jpg";